import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Report from "components/Report/Report";

import * as viewReducer from "containers/View/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as reportReducer from "containers/Report/ReportReducer";

const getId = (props) =>
  props && props.match && props.match.params && props.match.params.reportId ? props.match.params.reportId : "new";

class ReportContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.init();
  }

  render() {
    const { id } = this.props;

    return <Report {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    updateType: (type) => dispatch(viewReducer.updateType(type)),

    updateViewField: (datasetId, viewField) => dispatch(galleryReducer.updateViewField(datasetId, viewField)),
    updateStopReset: (datasetId, stopReset) => dispatch(galleryReducer.updateStopReset(datasetId, stopReset)),

    deleteChart: (chartId) => dispatch(reportReducer.deleteChart(id, chartId)),
    moveChart: (chartId, value) => dispatch(reportReducer.moveChart(id, chartId, value)),
    updateChartDescription: (chartId, description) =>
      dispatch(reportReducer.updateChartDescription(id, chartId, description)),
    updateChartSize: (chartId, size) => dispatch(reportReducer.updateChartSize(id, chartId, size)),
    updateChartTitle: (chartId, title) => dispatch(reportReducer.updateChartTitle(id, chartId, title)),
    updateChartType: (chartId, type) => dispatch(reportReducer.updateChartType(id, chartId, type)),
    cleanChartsOrder: () => dispatch(reportReducer.cleanChartsOrder(id)),
    init: () => dispatch(reportReducer.init(id))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id,
    report: reportReducer.getReport(state, id),
    chartsOrder: reportReducer.getChartsOrder(state, id),
    dataset: reportReducer.getLinkReportDataset(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ReportContainer);
